// extracted by mini-css-extract-plugin
export var active = "Header-module--active--f5fb2";
export var header = "Header-module--header--6bf56";
export var logo = "Header-module--logo--4f6b0";
export var navAndDarkmodeToggle = "Header-module--navAndDarkmodeToggle--7380e";
export var navigation = "Header-module--navigation--51ea6";
export var skip = "Header-module--skip--e375c";
export var slidein = "Header-module--slidein--dd2b2";
export var slideout = "Header-module--slideout--9ad34";
export var wrapper = "Header-module--wrapper--776ab";